<template>
  <div class="video">
    <div class="header">
      <div class="head_l">
        <div class="icon"><img src="~@/assets/images/icon_zdd.png"/></div>
        <div class="description">
          <p>轻松躺赚神器</p>
          <p>边玩游戏边赚钱 海量任务赚不停</p>
        </div>
      </div>
      <div class="head_r">
        <button @click="jump()">打开看看</button>
      </div>
    </div>
    <iframe :src="url" scrolling="no"></iframe>
  </div>
</template>

<style>
  body {
    background: #FFF;
  }
</style>

<style scoped>
  .video {
    display: block;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    position: relative;
  }
  .header {
    display: flex;
    width: 3.43rem;
    height: 0.62rem;
    padding: 0 .16rem;
    background-color: rgba(0, 0, 0, 0.6);
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
  }
  .header .head_l {
    display: block;
    height: 0.42rem;
  }
  .header .head_l .icon {
    display: block;
    float: left;
    width: .42rem;
    height: .42rem;
    overflow: hidden;
  }
  .header .head_l .description {
    display: flex;
    float: left;
    height: .42rem;
    margin-left: .1rem;
    color: #fff;
    flex-direction: column;
    justify-content: space-around;
    overflow: hidden;
  }
  .header .head_l .description p:first-child {
    font-size: 16px;
  }
  .header .head_l .description p:last-child {
    font-size: 12px;
  }
  .header .head_l .icon img {
    width: 100%;
  }
  .header .head_r {
    display: block;
    width: 0.8rem;
    height: 0.3rem;
    overflow: hidden;
  }
  .header .head_r button {
    display: block;
    width: 0.8rem;
    height: 0.3rem;
    font-size: 14px;
    line-height: 0.3rem;
    color: #FFFFFF;
    background-color: #FF7F4B;
    border: 0;
    border-radius: 0.15rem;
    outline: 0;
    overflow: hidden;
  }
  .header .head_r button:focus {
    outline: 0;
  }
  .video iframe {
    width: 100%;
    height: 100vh;
    border: 0;
    overflow: hidden;
  }
</style>

<script>

export default {
  created() {
    let url = this.$route.query.url
    this.url = decodeURIComponent(atob(url))
    this.userid = this.$route.query.userid
    this.title = this.$route.query.title
    document.title = this.title
  },
  data() {
    return {
      url: '',
      userid: '',
      title: ''
    }
  },
  methods: {
    jump: function () {
      this.$router.push({path:'invite', query:{userid: this.userid}})
    }
  }
}
</script>